import store from "..";
import { setTrainData } from "../Actions/train";
import { Train } from "../Reducers/types";

export const setTrain = (train: Train) => {
  store.dispatch(setTrainData(train));
};
